import { useSelector } from 'react-redux';
import BotListItem from '../botListItem/BotListItem';
import classes from './MobileBotListSheet.module.css';

export default function MobileBotListSheet({
  bots = [],
  activeRoutePath,
  onClose,
}) {
  const { texts } = useSelector((state) => state.translate);

  return (
    <div className={classes.Sheet} role="dialog" aria-modal="true" aria-label={texts.allMyBots}>
      <div className={classes.Body}>
        <h2 className={classes.ListTitle}>{texts.allMyBots}</h2>
        <ul className={classes.List}>
          {bots.map(({ projectKey, botName, routePath, headerBotName, subjectName, iconUrl, subjectIconUrl, approvedByPmr }, index) => {
            const isActive = (routePath || `${projectKey}/${botName}`) === activeRoutePath;
            const isLast = index === bots.length - 1;
            return (
              <li key={routePath || `${projectKey}/${botName}`} className={classes.ListItem}>
                <BotListItem
                  projectKey={projectKey}
                  botName={botName}
                  routePath={routePath}
                  headerBotName={headerBotName}
                  subjectName={subjectName}
                  iconUrl={iconUrl}
                  subjectIconUrl={subjectIconUrl}
                  approvedByPmr={approvedByPmr}
                  isActive={isActive}
                  showDivider={!isActive && !isLast}
                  onAfterSelect={onClose}
                />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
